import { Link } from 'react-router';
export { careersHandle as handle } from '../routeMetadata';
import { StandardPage } from '../components/StandardPage';
import { getAllCareers, type Career } from '../data/availableCareers';

export default function Careers() {
  const careers = getAllCareers();

  return (
    <div className="container mx-auto px-4 py-12 max-w-6xl">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold mb-4 text-blue-900 drop-shadow-sm tracking-tight">
          Join Our Team
        </h1>
        <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
          Be part of revolutionizing hygiene in New York. We're looking for passionate individuals 
          who want to make a difference in people's daily lives.
        </p>
      </div>

      {careers.length === 0 ? (
        <div className="bg-white/90 rounded-2xl shadow-xl p-12 text-center border border-blue-100">
          <h2 className="text-2xl font-semibold text-gray-800 mb-4">
            No Open Positions Currently
          </h2>
          <p className="text-gray-600 mb-6">
            We don't have any open positions at the moment, but we're always growing! 
            Check back soon or reach out to us directly.
          </p>
          <Link
            to="/about"
            className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            Learn More About Us
          </Link>
        </div>
      ) : (
        <div className="grid gap-8">
          {careers.map((career: Career) => (
            <div
              key={career.id}
              className="bg-white/90 rounded-2xl shadow-xl p-8 border border-blue-100 hover:shadow-2xl transition-shadow"
            >
              <div className="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-6">
                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-3 mb-4">
                    <h2 className="text-2xl font-bold text-blue-900">
                      {career.title}
                    </h2>
                    <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                      {career.type}
                    </span>
                  </div>
                  
                  <div className="flex flex-wrap gap-4 mb-4 text-gray-600">
                    <div className="flex items-center gap-1">
                      <span className="font-medium">Department:</span>
                      <span>{career.department}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <span className="font-medium">Location:</span>
                      <span>{career.location}</span>
                    </div>
                    {career.salary && (
                      <div className="flex items-center gap-1">
                        <span className="font-medium">Salary:</span>
                        <span>{career.salary}</span>
                      </div>
                    )}
                  </div>

                  <p className="text-gray-700 leading-relaxed mb-6">
                    {career.description}
                  </p>

                  <div className="flex flex-wrap gap-3">
                    <Link
                      to={`/careers/${career.id}`}
                      className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium"
                    >
                      View Details & Apply
                    </Link>
                    <div className="text-sm text-gray-500 flex items-center">
                      Click to see full job description and application form
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="mt-16 bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-8 text-center border border-blue-200">
        <h3 className="text-2xl font-bold text-blue-900 mb-4">
          Don't See the Right Position?
        </h3>
        <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
          We're always looking for talented individuals who share our passion for innovation 
          and customer service. Send us your resume and let us know how you'd like to contribute!
        </p>
        <a
          href="mailto:careers@bidetny.com"
          className="inline-block bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors font-medium"
        >
          Contact Us
        </a>
      </div>
    </div>
  );
}
